var canvas, canvas2, text, newText, zoom, cWidth = 2000, cHeight = 1400,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,
    placeholderimg1, placeholderimg2, placeholderimg3,
    placeholderimg4, placeholderimg5, placeholderimg6, placeholderimg7,
    placeholderimg8,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine,sizeBmW = 715, sizeBmH = 450,
    sizeB1W = 349, sizeB1H = 442,
    sizeB2W = 518, sizeB2H = 363,
    sizeB3W = 467, sizeB3H = 363,
    sizeB4W = 420, sizeB4H = 444,
    sizeB5W = 419, sizeB5H = 523;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');




let backImg = document.querySelector("#background_birthday");
let bg_img = new fabric.Image(backImg, {
  left: 0,   
  top: 0,
  scaleX: 1.951,
  scaleY: 1.951,
  selectable: false
});

let frameImg = document.querySelector("#design_birthday");
let simpleImage = new fabric.Image(frameImg, {
  left: 0,   
  top: 0,
  scaleX: 1.951,
  scaleY: 1.951,
  selectable: false
});
window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

window['canvas2'].add(bg_img);
bg_img.sendToBack();
window['canvas2'].add(simpleImage);
simpleImage.bringToFront();
addModify(window['canvas2']);





//-------------- Heart Calendar --------------

const dayNames = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

var inputDate = '2023-10-15',
  calendarGroup;


const cellWidth = 40;
const cellHeight = 28;
const startX = 40;
const startY = 140;


//var svgEl = document.body.getElementsByTagName('svg')[0];
var svgEl = document.getElementById('heart_cIcon');
var serializer = new XMLSerializer();
var svgStr = serializer.serializeToString(svgEl);

var path,outline;

document.getElementById('calendar-date').addEventListener('input', () => {
    const inputDate = document.getElementById('calendar-date').value;
    window['canvas2'].remove(calendarGroup);
    drawCalendar(inputDate);
});

function drawCalendar(inputDate){
    if (!inputDate) {
        return;
    }

    const selectedDate = new Date(inputDate);
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();
    const selectedDay = selectedDate.getDate();

    calendarGroup = new fabric.Group([], {
        left: 0,
        top: 0,
        fill: 'rgba(0,0,0,0)',
        selectable: true
    });

    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const firstDayOfWeek = firstDay.getDay();
    const totalDays = lastDay.getDate();

  const monthYearTitle = new fabric.Text(
  `${firstDay.toLocaleString('default', { month: 'long' })}`, {
    left: 185,
    top: 55,
    fontSize: 26,
    fontFamily: 'Poppins',
    textAlign: 'center',
    originX: 'center',
    fill: 'white'
  }
);
calendarGroup.addWithUpdate(monthYearTitle);

    dayNames.forEach((day, index) => {
        const dayText = new fabric.Text(day, {
            left: startX + index * cellWidth + cellWidth / 2,
            top: 105,
            fontSize: 18,
            fontFamily: 'Poppins',
            textAlign: 'center',
            originX: 'center',
            fill:'white'
        });
        calendarGroup.addWithUpdate(dayText);
    });

    let currentDay = 1;
    for (let row = 0; row < 6; row++) {
        for (let col = 0; col < 7; col++) {
            const x = startX + col * cellWidth;
            const y = startY + row * cellHeight;

            const rect = new fabric.Rect({
                left: x,
                top: y,
                width: cellWidth,
                height: cellHeight,
                fill: 'transparent',
            });
            calendarGroup.addWithUpdate(rect);

            if (row === 0 && col < firstDayOfWeek || currentDay > totalDays) {
                continue;
            }

            if (currentDay === selectedDay) {
                fabric.loadSVGFromString(svgStr, function(objects, options) {
                    var obj = fabric.util.groupSVGElements(objects, options);
                    obj.scaleToHeight(36).set({
                        left: x + 3,
                        top: y - 2
                    }).setCoords();
                    calendarGroup.addWithUpdate(obj);
                });
            }

            const dateText = new fabric.Text(currentDay.toString(), {
                left: x + cellWidth / 2,
                top: y + cellHeight / 2,
                fontSize: 19,
                fontFamily: 'Poppins',
                textAlign: 'center',
                originX: 'center',
                originY: 'center',
                fill: 'white',
                selectable: false
            });
            calendarGroup.addWithUpdate(dateText);
            currentDay++;
        }
    }

    calendarGroup.scaleToWidth(600);
    calendarGroup.left = 335;
    calendarGroup.top = 325;
    window['canvas2'].add(calendarGroup);
}


window['placeholderimg1'] = new fabric.Rect({
  left: 1401,
  top: 272,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
  rx: 25,  // Border radius X
  ry: 25,  // Border radius Y
  stroke: 'white',
  strokeWidth: 4
});

window['placeholderimg2'] = new fabric.Rect({
  left: 1778,
  top: 272,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
  rx: 25,  // Border radius X
  ry: 25,  // Border radius Y
  stroke: 'white',
  strokeWidth: 4
});

window['placeholderimg3'] = new fabric.Rect({
  left: 1401,
  top: 740,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
  rx: 25,  // Border radius X
  ry: 25,  // Border radius Y
  stroke: 'white',
  strokeWidth: 4
});

window['placeholderimg4'] = new fabric.Rect({
  left: 1778,
  top: 740,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
  rx: 25,  // Border radius X
  ry: 25,  // Border radius Y
  stroke: 'white',
  strokeWidth: 4
});

window['placeholderimg5'] = new fabric.Rect({
  left: 1691,
  top: 1167,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)',
  rx: 25,  // Border radius X
  ry: 25,  // Border radius Y
  stroke: 'white',
  strokeWidth: 4
});

window['placeholderimg6'] = new fabric.Rect({
  left: 1174,
  top: 1167,
  width: sizeB3W,
  height: sizeB3H,
  fill: 'rgba(0,0,0,0.1)',
  rx: 25,  // Border radius X
  ry: 25,  // Border radius Y
  stroke: 'white',
  strokeWidth: 4
});

window['placeholderimg7'] = new fabric.Rect({
  left: 705,
  top: 1128,
  width: sizeB4W,
  height: sizeB4H,
  fill: 'rgba(0,0,0,0.1)',
  rx: 25,  // Border radius X
  ry: 25,  // Border radius Y
  stroke: 'white',
  strokeWidth: 4
});

window['placeholderimg8'] = new fabric.Rect({
  left: 260,
  top: 1087,
  width: sizeB5W,
  height: sizeB5H,
  fill: 'rgba(0,0,0,0.1)',
  rx: 25,  // Border radius X
  ry: 25,  // Border radius Y
  stroke: 'white',
  strokeWidth: 4
});


window['canvas2'].add(window['placeholderimg1'], window['placeholderimg2'], window['placeholderimg3'], window['placeholderimg4'],window['placeholderimg5'], window['placeholderimg6'], window['placeholderimg7'], window['placeholderimg8']);



window['border1'] = new fabric.Rect({
  left: 1401,
  top: 272,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'transparent',
  rx: 25,
  ry: 25,
  stroke: 'white',
  strokeWidth: 4
});

window['border2'] = new fabric.Rect({
  left: 1778,
  top: 272,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
  rx: 25,
  ry: 25,
  stroke: 'white',
  strokeWidth: 4
});

window['border3'] = new fabric.Rect({
  left: 1401,
  top: 740,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'transparent',
  rx: 25,
  ry: 25,
  stroke: 'white',
  strokeWidth: 4
});

window['border4'] = new fabric.Rect({
  left: 1778,
  top: 740,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'transparent',
  rx: 25,
  ry: 25,
  stroke: 'white',
  strokeWidth: 4
});

window['border5'] = new fabric.Rect({
  left: 1691,
  top: 1167,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'transparent',
  rx: 25,
  ry: 25,
  stroke: 'white',
  strokeWidth: 4
});

window['border6'] = new fabric.Rect({
  left: 1174,
  top: 1167,
  width: sizeB3W,
  height: sizeB3H,
  fill: 'transparent',
  rx: 25,
  ry: 25,
  stroke: 'white',
  strokeWidth: 4
});

window['border7'] = new fabric.Rect({
  left: 705,
  top: 1128,
  width: sizeB4W,
  height: sizeB4H,
  fill: 'transparent',
  rx: 25,
  ry: 25,
  stroke: 'white',
  strokeWidth: 4
});

window['border8'] = new fabric.Rect({
  left: 260,
  top: 1087,
  width: sizeB5W,
  height: sizeB5H,
  fill: 'transparent',
  rx: 25,
  ry: 25,
  stroke: 'white',
  strokeWidth: 4
});


window['canvas2'].add(window['border1'], window['border2'], window['border3'], window['border4'],window['border5'], window['border6'], window['border7'], window['border8']);

drawCalendar(inputDate);

document.getElementById('image_upload_first').addEventListener('change',function(e){
   canvas = window['canvas2'];
   img = window['placeholderimg1'];
   outline = window['border1'];
   available_height = img.height;
   sizeCrop = '0.79';
   reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
   readURL2(e.target);
 });

document.getElementById('image_upload_second').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg2'];
  outline = window['border2'];
  available_height = img.height;
  sizeCrop = '0.79';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_third').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg3'];
  outline = window['border3'];
  available_height = img.height;
  sizeCrop = '0.79';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_fourth').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg4'];
  outline = window['border4'];
  available_height = img.height;
  sizeCrop = '0.79';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_fifth').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg5'];
  outline = window['border5'];
  available_height = img.height;
  sizeCrop = '1.43';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_sixth').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg6'];
  outline = window['border6'];
  available_height = img.height;
  sizeCrop = '1.29';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_seventh').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg7'];
  outline = window['border7'];
  available_height = img.height;
  sizeCrop = '0.95';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_eight').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg8'];
  outline = window['border8'];
  available_height = img.height;
  sizeCrop = '0.8';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});


var maxWidth = 470;
var maxHeight = 650;

var para = "May this year be filled\nwith endless happiness,\nboundless opportunities,\nand dreams that turn into\nbeautiful realities.\nMay laughter always echo\naround you, love surround\nyou in every moment,\nand success follow you\nin all that you do." ;

window['text1Page'] = new fabric.Text(para,{
  left: 915,
  top: 435,
  width: 180,
  fontSize: 45,
  fontFamily: 'Kalam',
  textAlign: 'center',
  isWrapping: true,
  fill: 'white'
});

var fontName2 = window['text1Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName2 + "'").trigger('change');

window['canvas2'].add(window['text1Page']);


var minFontSize = 10;
var maxFontSize = 55;

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'May this year be filled\nwith endless happiness,\nboundless opportunities,\nand dreams that turn into\nbeautiful realities.\nMay laughter always echo\naround you, love surround\nyou in every moment,\nand success follow you\nin all that you do.') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText2(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_1').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text1Page'].set({
    text: input
  });
  fitTextToBox(window['text1Page'], maxWidth, maxHeight);
});

function fitTextToBox(textObj, maxWidth, maxHeight) {
  let fontSize = maxFontSize;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth || textObj.height > maxHeight;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}


var maxWidth2 = 400;
var maxHeight2 = 200;

window['text2Page'] = new fabric.Text('Happy\nAnniversary',{
  left: 360,
  top: 680,
  fontSize: 80,
  lineHeight: 1,
  fontFamily: 'Elicit Script',
  fill: 'white',
  textAlign: 'center',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName2 = window['text2Page'].fontFamily;
jQuery('.choose_font2').val("'" + fontName2 + "'").trigger('change');

window['canvas2'].add(window['text2Page']);


var minFontSize2 = 10;
var maxFontSize2 = 90;

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'Happy\nAnniversary') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText2(textbox, maxW, maxH) {
  let fontSize = maxFontSize2;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize2
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_2').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text2Page'].set({
    text: input
  });
  fitTextToBox2(window['text2Page'], maxWidth2, maxHeight2);
});

function fitTextToBox2(textObj, maxWidth2, maxHeight2) {
  let fontSize = maxFontSize2;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth2 || textObj.height > maxHeight2;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize2) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}




window['text3Page'] = new fabric.Text('Ayesha Rani',{
  left: 900,
  top: 835,
  fontSize: 70,
  fontFamily: 'Galada',
  fill: 'white',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text3Page'].fontFamily;
jQuery('.choose_font3').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text3Page']);

// Clear text on input focus if default
document.getElementById('text_3').addEventListener('focus', function () {
  if (window['text3Page'].text === 'Ayesha Rani') {
    window['text3Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 70; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_3').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text3Page'].set('text', newText);
  fitTextToWidth(window['text3Page'], 450);
  window['text3Page'].bringToFront();
  window['canvas2'].renderAll();
});




window['text55Page'] = new fabric.Text('@tasweer.com.pk',{
  left: 1880,
  top: 1368,
  fontSize: 16,
  fontFamily: 'Baloo2',
  fill: '#fff',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});


window['canvas2'].add(window['text55Page']);






function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
        clipPath: new fabric.Rect({
          width: img.width,
          height: img.height,
          rx: 20, // Apply border radius from placeholder
          ry: 20
        })
      });
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  fabric.Image.fromURL(imgurl, function(newImg){
    const scale = newImg.width / img.width;
    newImg.set({
      left: img.left,
      top: img.top,
      originX: 'center',
      originY: 'center'
    });
    newImg.scaleToHeight(available_height);
    
    const clipPath = new fabric.Rect({
      width: newImg.width,
      height: newImg.height,
      rx: img.rx * scale,
      ry: img.ry * scale,
      left: 0,
      top: 0,
      originX: 'center',
      originY: 'center',
      fill: 'transparent'
    });
    
    newImg.clipPath = clipPath;


    canvas.add(newImg);
    canvas.bringToFront(outline);
    img = newImg;
    canvas.renderAll();
    
    /*const border = new fabric.Rect({
      width: img.width,
      height: img.height,
      rx: img.rx,
      ry: img.ry,
      left: img.left,
      top: img.top,
      originX: 'center',
      originY: 'center',
      fill: 'transparent',
      stroke: img.stroke,
      strokeWidth: img.strokeWidth,
      selectable: false
    });
    
    const group = new fabric.Group([newImg, border], {
      left: img.left,
      top: img.top,
      originX: 'center',
      originY: 'center',
      selectable: true
    });
    canvas.add(group).renderAll();*/
  });
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});

jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  canvas.renderAll();
  fitTextToBox(window['text1Page'], maxWidth, maxHeight);
  fitTextToBox2(window['text2Page'], maxWidth2, maxHeight2);
  fitTextToWidth(window['text3Page'], 450);
});

function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('data-canvas'),
          textOb = colorBox.attr('data-obj'),
          active = colorBox.find('.currentColor'),
          activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      canvas = window[colorID];
      activeOb = window[textOb];
      sCAle = activeOb.scaleX;
      activeOb.set('fill',activeCOLOR);
      activeOb.scaleX = .5;
      activeOb.setCoords();
      canvas.renderAll();
      activeOb.scaleX = sCAle;
      activeOb.setCoords();
      canvas.renderAll();
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});

// function showExtras(canvas){
//   vLine.set({
//     visible: true
//   });
//   leftMarker.set({
//     visible: true
//   });
//   rightMarker.set({
//     visible: true
//   });
//   canvas.renderAll();
// }

// function hideExtras(canvas){
//   vLine.set({
//     visible: false
//   });
//   leftMarker.set({
//     visible: false
//   });
//   rightMarker.set({
//     visible: false
//   });
//   canvas.renderAll();
// }



async function handleUpload(fileInputs,timeID){
  const temp_images = [];
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    const croppedURL = jQuery(input).attr('data-cropped');
    if(croppedURL != ''){
      temp_images.push(croppedURL);
    }
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1, wall = 1, upCrop;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        if (int % 2 === 0) {
          upCrop = 'User Uploaded ';
        }else{
          upCrop = 'Cropped ';
        }
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties['+ upCrop + wall+']">');
        if(upCrop == 'User Uploaded '){
          wall += 1;
        }
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}


/* fetch Call */
var size,thumbnail;
var loadedObject,selectDate,enterText,Font1,enterEvent,Font2,enterName,image1,additionalInfo,frameColor,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    window['canvas2'] = canvas.toDataURL('image/png');
    selectDate = jQuery('.calendar-date input').val();
    enterText = jQuery('.enter_text textarea').val();
    Font1 = jQuery('.Font1 option:selected').val();
    enterEvent = jQuery('.enter_event textarea').val();
    Font2 = jQuery('.Font2 option:selected').val();
    enterName = jQuery('.enter_name input').val();
    Font3 = jQuery('.Font3 option:selected').val();
    image1 = jQuery('#image_upload_first').val();
    frameColor = jQuery('.frameColorBox').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#selectDate').val(selectDate);
      jQuery('#enterText').val(enterText);
      jQuery('#chooseFont1').val(Font1);
      jQuery('#enterEvent').val(enterEvent);
      jQuery('#chooseFont2').val(Font2);
      jQuery('#enterName').val(enterName);
      jQuery('#chooseFont3').val(Font3);
      jQuery('#Image1').val(image1);
      jQuery('#selected_frameColor').val(frameColor);
      jQuery('#addInfo').val(additionalInfo);
      //console.log('Server response:', data);
      const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});

function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    //loadedObject.scaleToWidth(canvas.width);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}